module.exports = __webpack_public_path__ + "static/media/img_casks_header.d85fe1fa.png";